// src/components/InactivityWarning.jsx
import React from 'react';
import { Clock } from 'lucide-react';

export default function InactivityWarning({ show, secondsLeft, onContinue, onLogout }) {
  if (!show) return null;

  const pct  = Math.min(100, Math.max(0, (secondsLeft / 120) * 100));
  const deg  = (pct / 100) * 360;

  const overlay = {
    position: 'fixed', inset: 0, zIndex: 99999,
    background: 'rgba(0,0,0,0.75)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    backdropFilter: 'blur(4px)',
    animation: 'fadeIn 0.2s ease',
  };

  const card = {
    background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: '20px',
    padding: '40px 48px',
    maxWidth: '440px',
    width: '90%',
    boxShadow: '0 25px 60px rgba(0,0,0,0.6)',
    textAlign: 'center',
    color: '#f1f5f9',
  };

  const ring = {
    width: 96, height: 96,
    borderRadius: '50%',
    background: `conic-gradient(
      ${secondsLeft < 30 ? '#ef4444' : secondsLeft < 60 ? '#f59e0b' : '#22c55e'} ${deg}deg,
      rgba(255,255,255,0.08) ${deg}deg
    )`,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    margin: '0 auto 24px',
    position: 'relative',
  };

  const ringInner = {
    width: 72, height: 72, borderRadius: '50%',
    background: '#0f172a',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 26, fontWeight: 700,
    color: secondsLeft < 30 ? '#ef4444' : secondsLeft < 60 ? '#f59e0b' : '#22c55e',
  };

  const btnPrimary = {
    background: 'linear-gradient(135deg, #22c55e, #16a34a)',
    border: 'none', borderRadius: 10,
    color: '#fff', fontWeight: 600, fontSize: 15,
    padding: '12px 28px', cursor: 'pointer',
    flex: 1, transition: 'opacity 0.2s',
  };

  const btnSecondary = {
    background: 'transparent',
    border: '1px solid rgba(239,68,68,0.6)',
    borderRadius: 10, color: '#ef4444',
    fontWeight: 600, fontSize: 15,
    padding: '12px 28px', cursor: 'pointer',
    flex: 1, transition: 'all 0.2s',
  };

  return (
    <>
      <style>{`@keyframes fadeIn{from{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}`}</style>
      <div style={overlay}>
        <div style={card}>
          {/* Icon */}
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 12 }}>
            <Clock size={36} color="var(--warning, #f59e0b)" />
          </div>
          <h2 style={{ margin: '0 0 8px', fontSize: 22, fontWeight: 700 }}>
            Are you still there?
          </h2>
          <p style={{ color: '#94a3b8', margin: '0 0 28px', fontSize: 14, lineHeight: 1.6 }}>
            You will be automatically logged out due to inactivity in
          </p>

          {/* Countdown ring */}
          <div style={ring}>
            <div style={ringInner}>{secondsLeft}</div>
          </div>
          <p style={{ color: '#64748b', fontSize: 13, marginBottom: 28 }}>seconds</p>

          {/* Buttons */}
          <div style={{ display: 'flex', gap: 12 }}>
            <button
              id="inactivity-continue-btn"
              style={btnPrimary}
              onMouseOver={e => e.target.style.opacity = '0.85'}
              onMouseOut={e => e.target.style.opacity = '1'}
              onClick={onContinue}
            >
              Continue Working
            </button>
            <button
              id="inactivity-logout-btn"
              style={btnSecondary}
              onMouseOver={e => { e.target.style.background = 'rgba(239,68,68,0.1)'; }}
              onMouseOut={e => { e.target.style.background = 'transparent'; }}
              onClick={onLogout}
            >
              Logout Now
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
